import type { TMinLengthValidatorParams } from '@ballerine/common';

import type { TValidator } from '../../types';
import { formatErrorMessage } from '../../utils/format-error-message';

export const minLengthValidator: TValidator<string, TMinLengthValidatorParams> = (
  value,
  params,
) => {
  const { message = 'Minimum length is {minLength}.' } = params;

  if (value?.length === undefined) return true;

  if (value?.length < params.value.minLength) {
    throw new Error(formatErrorMessage(message, 'minLength', params.value.minLength.toString()));
  }
};
